import { Patch } from "..";

export default [
    {
        name: "PF 倒计时冻结",
        patches: [{ offset: 0x70D0DD, off: [0x7E], on: [0xEB] }],
    },
    {
        name: "选曲游标锁定",
        patches: [{ offset: 0x755E1C, off: [0x74, 0x21], on: [0x90, 0x90] }],
    },
    {
        name: "开始时按住 START 一直暂停歌曲",
        patches: [{ offset: 0x776937, off: [0x7D, 0x36], on: [0x90, 0x90] }],
    },
    {
        name: "在 LDJ 模式下使用自定义帧数",
        patches: [
            { offset: 0x68A853, off: [0x75], on: [0xEB] },
            { offset: 0x8992A7, off: [0x74, 0x03], on: [0x90, 0x90] },
        ]
    },
    {
        type: "union",
        name: "选择自定义的帧数",
        offset: 0x899091,
        patches: [
            {
                name: "60 FPS (默认)",
                patch: [0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x3C, 0x00, 0x00, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xFF, 0x01, 0x00, 0x00, 0x00, 0x48, 0x8B, 0x45, 0xD7, 0x48, 0x89, 0x45, 0x03, 0xC7, 0x45, 0xD7, 0x01, 0x00, 0x00, 0x00, 0xC7, 0x45, 0xDB, 0x78, 0x00, 0x00, 0x00],
            }
        ]
    },
    {
        type: "union",
        name: "选择显示器检测目标 FPS",
        offset: 0x79BA96,
        patches: [
            {
                name: "60 FPS",
                patch: [0x3C, 0x00],
            },
            {
                name: "120 FPS",
                patch: [0x78, 0x00],
            }
        ]
    },
    {
        name: "更快的快速重试",
        tooltip: "缩短 'STAGE FAILED' 动画的长度.",
        patches: [{ offset: 0x775DE5, off: [0x7C, 0x12], on: [0x90, 0x90] }],
    },
    {
        name: "启用 TDJ 模式",
        patches: [{ offset: 0x899492, off: [0x02], on: [0x03] }],
    },
    {
        name: "WASAPI 共享模式 (增加延迟)",
        patches: [{ offset: 0x44CACB, off: [0x44, 0x8B, 0xF2], on: [0x4D, 0x31, 0xF6] }],
    }, 
    {
        name: "跳过显示器检测",
        patches: [
            { offset: 0x7940CA, off: [0x8C], on: [0x8D] },
            { offset: 0x79412A, off: [0x77, 0x0E], on: [0x90, 0x90] },
            { offset: 0x794134, off: [0x0F, 0x86, 0x8B, 0x00, 0x00, 0x00], on: [0xE9, 0x8C, 0x00, 0x00, 0x00, 0x90] },
        ],
    }, 
    {
        type: "union",
        name: "跳过显示器检测 FPS",
        offset: 0x7A8B47,
        patches: [
            {
                name: "不修改",
                patch: [0x44, 0x8B, 0xCA, 0x4C, 0x8B, 0xD9, 0x41, 0x81, 0xC2, 0x67, 0x01, 0x00, 0x00, 0xB8, 0xB7, 0x60, 0x0B, 0xB6, 0x0F, 0x57],
            },
            {
                name: "60.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x4E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            },
            {
                name: "120.0000 FPS",
                patch: [0x48, 0xB8, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x5E, 0x40, 0x66, 0x48, 0x0F, 0x6E, 0xC0, 0xF2, 0x0F, 0x58, 0xC8, 0xC3],
            }
        ]
    },
    {
        name: "阻止调整系统音量",
        tooltip: "spice2x 现在自带这个功能了快去更新吧",
        type: "tooltip",
    },
    {
        name: "最大游戏音量",
        tooltip: "忽略游戏内音量设置转而使用最大音量, 适用于声音很轻的情况。当你想要使用 TDJ 自带的耳机音量调节时请勿开启。",
        patches: [{ offset: 0x8BAE05, off: [0xFF, 0x90, 0x98, 0x00, 0x00, 0x00, 0x90], on: [0x90, 0x90, 0x90, 0x90, 0x90, 0x90, 0x90] }],
    },
    {
        name: "歌曲全解",
        patches: [{ offset: 0x706FCA, off: [0x32, 0xC0], on: [0xB0, 0x01] }],
    },
] as Patch[];
